<button class="cart-btn primary-bg-color primary-text-color primary-border-color" 
        [attr.aria-label]="order?.itemsCount ? (('component.header.cart_button.button_title' | translate) + ', ' + order.itemsCount + ' ' + (order.itemsCount === 1 ? 'item' : 'items')) : ('component.header.cart_button.button_title' | translate)">
  <fa-icon [size]="'lg'" [fixedWidth]="true" [icon]="faFtsCart"></fa-icon>
  <span *ngIf="order?.itemsCount" class="item-count fw-600" aria-hidden="true">{{order?.itemsCount}}</span>
</button>
